import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiAxios, ifsApi } from "lib/axios";

// ─── Types ───

export interface FuelStation {
  id: string;
  customer: string;
  storeNumber: string;
  price: number;
  discountedPrice: number;
  city: string;
  state: string;
  status: "1" | "0";
}

// ─── Queries ───

async function getFuelLocations(companyId: string): Promise<FuelStation[]> {
  const response = await ifsApi.get(`/customers/${companyId}/fuel-stations`);
  return response.data.data;
}

export const fuelLocationsOptions = (companyId: string) =>
  queryOptions({
    queryKey: ["fuel-locations", companyId],
    queryFn: () => getFuelLocations(companyId),
  });

// ─── Mutations ───

async function updateFuelLocation(companyId: string, id: string, status: 0 | 1): Promise<void> {
  await apiAxios.get(`/ifs_uFuelStation`, {
    params: {
      customer: companyId,
      id,
      switch: status,
    },
  });
}

export function useUpdateFuelLocation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, id, status }: { companyId: string; id: string; status: 0 | 1 }) =>
      updateFuelLocation(companyId, id, status),
    onSuccess: (_data, { companyId }) =>
      queryClient.invalidateQueries({ queryKey: ["fuel-locations", companyId] }),
  });
}
